/** Client signup URL that prefills expertRef and auto-links on register (after company verification). */
export function buildExpertClientSignupUrl(
  referenceId: string,
  origin: string = typeof window !== "undefined" ? window.location.origin : "",
): string {
  const trimmed = referenceId.trim().toUpperCase();
  const url = new URL("/signup", origin || "http://localhost");
  url.searchParams.set("expertRef", trimmed);
  return url.toString();
}
